export const realms = {
  admin: 'core',

  klient: 'endusers',
  podpis: 'endusers',

  brokertrust: 'bt',
  sabservis: 'ss',
  datalife: 'dl',
  holver: 'ho',
  chytryhonza: 'ch',
  ininvest: 'in',
  fingo: 'fg',
  collega: 'co',
  okklient: 'ok',
  brokeroffice: 'bo',
  stconsult: 'st',
  '1vpas': 'vp',
  kapitol:'ka',
  beplan: 'be',
  edo: 'ed',
  wood: 'wo',
  kz: 'kz',
  alfafinance: 'af',
  jplservis: 'js',
  'i-cm': 'ic'
};

export const idp = ['bt'];

export const clients = {
  klient: 'client_portal',
  podpis: 'client_portal_sign',
};
